export const LOCATION_CITIES_WITH_LOCAL_BUSINESS_SCHEMA = [
  'birmingham',
  'london',
  'manchester',
] as const;

export const LOCATION_CITIES = [
  ...LOCATION_CITIES_WITH_LOCAL_BUSINESS_SCHEMA,
  'bradford',
  'brighton',
  'bristol',
  'cardiff',
  'coventry',
  'derby',
  'doncaster',
  'edinburgh',
  'glasgow',
  'leeds',
  'leicester',
  'lincoln',
  'liverpool',
  'newcastle',
  'nottingham',
  'sheffield',
  'southampton',
] as const;
